import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import DatePicker from "react-datepicker";
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {
	FormGroup,
	Label,	
} from 'reactstrap';
import {
    ResponsiveContainer,    
    LineChart,
	Line,    
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,    
  } from "recharts";
  import ChartConfig, { tooltipStyle, tooltipTextStyle } from 'Constants/chart-config';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
import ProgressLoader from 'Components/Widgets/ProgressLoader';

import { 
    stdBDTenPutts,
    addBDTenPutts,
    fetchPuttDistance,
 } from 'Actions';

 import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

class PuttItems extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,
    };

    UNSAFE_componentWillMount() {
        
	}
    constructor(props) {
      
        super(props);
        this.state = {  
            startdate:this.props.data.startdate, 
            enddate:this.props.data.enddate,
            student:this.props.data.student, 
            loader:false,
            putsepmore:this.props.data.putsepmore,
            puttformValues: this.props.data.puttformValues,
            putlinedata:this.props.data.putlinedata,
            pointchart:true,
            putlinemax:this.props.data.putlinemax,
            totavgputts:this.props.data.totavgputts,
        };
        
        this.chartValue = this.chartValue.bind(this); 

    }

    addHandleSubmit(event){
        event.preventDefault();
        this.setState({ loader:true });
        var putsepmore=this.state.putsepmore;
        var student=this.state.student;
        var start=this.state.startdate;
        var end=this.state.enddate;
        this.props.addBDTenPutts(student, start, end, event, putsepmore).then((data) => {   
            
            this.setState({ 
                loader:false
            });

        });
        
    }

    filterDateSubmit(){
        var student=this.state.student;
        var stdate=moment(new Date(this.state.startdate)).format('yyyy-MM-DD');
        var eddate=moment(new Date(this.state.enddate)).format('yyyy-MM-DD');
        
        this.setState({ 
            loader:true,
        });

        this.props.stdBDTenPutts(student, stdate, eddate).then((data) => {   
            var resdata=data.data;
            var alldata=[]; 
            var highval=[];
            var st=0;
            if(resdata.length!=0){
               
                {resdata.map((teamval, idx) => (   
                                       
                    alldata.push({
                        x:idx+1,
                        y:teamval.gpb_points,
                    }),
                    highval[idx]=teamval.gpb_points,
                    st=st+teamval.gpb_points
                    
                ))}               
                
                const maxNumber = Math.max(...highval)+10;
                this.setState({
                   
                    putlinedata:[...alldata],
                    putlinemax:maxNumber
                });
            }else{
                this.setState({                   
                    putlinedata:[],
                    putlinemax:20,  
                });  
            }

            this.setState({ 
                loader:false, 
            });

        });
        
    }

    selectstart = (date) => {  
        this.setState({ startdate:date });           
    }

    selectend = (date) => {  
        this.setState({ enddate:date });           
    }
    
    addFormFields() {
        var chktotal=this.state.putsepmore;
        var totalsep=chktotal+1;
        this.setState(({
          putsepmore:totalsep,  
          puttformValues: [...this.state.puttformValues, { puttdate:"", noputt:""}]
        }))
    }
    
    removeFormFields(i) {
        let puttformValues = this.state.puttformValues;
        var chktotal=this.state.putsepmore;
        var totalsep=chktotal-1;
        puttformValues.splice(i, 1);
        this.setState({ puttformValues, putsepmore:totalsep });
        this.chartValue(totalsep);
    }

    handleChange(i,e, frm) {
        let puttformValues = this.state.puttformValues;  
        
        if(frm==1){
            puttformValues[i]['puttdate'] = e; 
            this.setState({ puttformValues });
        }else{
            puttformValues[i][e.target.name] = e.target.value; 
            this.setState({ puttformValues }); 
            
        }

        if(frm==2){           
            this.chartValue(i+1);
        }

    }

    chartValue(total){
        
        this.setState({pointchart:false}); 
        let puttformValues = this.state.puttformValues; 
        var alldata=[]; 
        var highval=[];
        var st=0;
        for(let d = 0; d<total; d++) {
            var puttval=puttformValues[d]['noputt'];
            var start=d;
            var xval=start+1;
            alldata[d]={x:xval, y:puttval};
            highval[d]=puttval;
            if(puttval!=""){
                st=parseFloat(st)+parseFloat(puttval);
            }
        }     
        var totavg=parseFloat((st/total).toFixed(2));   
        const maxNumber = Math.max(...highval)+10;        
        this.setState({ putlinedata: [...alldata], putlinemax:maxNumber, totavgputts:totavg});
        this.setState({pointchart:true});
    }    

    handleNumberic(e) {               
        if (!/[0-9,.,-]/.test(e.key)) {
            e.preventDefault();
        } 
    }


render() {

    const { studentlists, loading} = this.props;   
    const allstudent=studentlists.map((stdval) => {  
        return {
           label: stdval.student,  
           value: stdval.uudID
        }
    });

      return(
        <div>
            <div className="col-lg-12">
                <form autoComplete="off" id="addform" onSubmit={(e)=>this.addHandleSubmit(e)}>
                     <div className="row">
                        <div className="col-sm-12 col-lg-12" style={{margin:"0 auto"}}>
                            <RctCollapsibleCard heading="10FT BROADIE DRILL - PUTTS SYSTEM">
                            <div className="col-sm-12 col-lg-12"><h5 style={{color:"blue"}}>How many putts did it take you to get to 10 points?</h5></div>
                                    <div className="row">                                          
                                        <div className="col-sm-12 col-lg-5"> 
                                            <div className="form-group">
                                                <div className="table-responsive" style={{height:"300px"}}>
                                                    <Table>
                                                        <TableHead style={{position:"sticky", top:"0"}}>
                                                            <TableRow hover>
                                                                <TableCell align="center" width={'10%'}>NO.</TableCell>   
                                                                <TableCell align="center" width={'20%'}>DATE</TableCell>
                                                                <TableCell align="center" width={'30%'}>PUTTS TAKEN TO REACH 10 POINTS </TableCell>                                                                
                                                                <TableCell align="center" width={'10%'}>DELETE</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>

                                                        {this.state.puttformValues.map((element, i) => (
                                                             
                                                            <TableRow key={i}>
                                                            <TableCell>{i+1}</TableCell>    
                                                            <TableCell>
                                                                        <DatePicker className="form-control" name={'puttdate'} id={'puttdate_'+i} required autoComplete="off" 
                                                                        selected={element.puttdate}
                                                                        onChange={e => this.handleChange(i, e, 1)}
                                                                        dateFormat='yyyy-MM-dd'
                                                                        peekNextMonth
                                                                        showMonthDropdown
                                                                        showYearDropdown 
                                                                    /> 
                                                            </TableCell>
                                                            <TableCell><input type="text" name={'noputt'} id={'noputt_'+i} value={element.noputt || ""} onKeyPress={e => this.handleNumberic(e)}  onChange={e => this.handleChange(i, e, 2)} className="form-control form-control-alternative" required/></TableCell>                                                            
                                                            <TableCell>
                                                                
                                                                    <IconButton style={{ width: "10px", height: "10px"}} className="text-danger" aria-label="Remove" onClick={() => this.removeFormFields(i)}  > <DeleteOutlineOutlinedIcon/></IconButton> 
                                                                       
                                                            </TableCell>
                                                            </TableRow>
                                                        ))}
                                                        </TableBody>
                                                    </Table>   
                                                </div>  
                                            </div>   
                                            <div className="col-lg-12" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <div style={{ flex: '0 0 auto', width: '20%' }}>
                                                    <span style={{ color: "red" }}><strong>PGA, AVG - 11</strong></span>
                                                </div>
                                                <div style={{ flex: '0 0 auto', width: '50%' }}>
                                                    <Table>
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell></TableCell>
                                                                <TableCell><strong>AVG Points</strong></TableCell>
                                                                <TableCell><input type="text" name={'totalavg'} value={this.state.totavgputts} className="form-control form-control-alternative" readOnly /></TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </div>
                                                <div style={{ flex: '0 0 auto', width: '20%' }}>
                                                    <button className="mr-3 mb-3 btn btn-outline-primary btn-sm float-right" type="button" onClick={() => this.addFormFields()}> <i className="zmdi zmdi-plus-circle-o"></i> add shot</button>
                                                </div>
                                            </div>
                                        </div>
                                        {this.state.pointchart &&
                                        <div className="col-sm-12 col-lg-7">
                                            <div className="row" style={{marginTop:"-50px"}}> 
                                                <div className="col-lg-4"></div>                                  
                                                <div className="col-lg-3">
                                                    <FormGroup >
                                                        <DatePicker className="form-control" id="startdate" placeholderText="Start Date"  name="startdate" autoComplete="off" 
                                                                selected={this.state.startdate}
                                                                onChange={this.selectstart}
                                                                dateFormat='yyyy-MM-dd'
                                                                peekNextMonth
                                                                showMonthDropdown
                                                                showYearDropdown 
                                                            /> 
                                                    </FormGroup>                                          
                                                </div>
                                                <div className="col-lg-3">
                                                    <FormGroup >
                                                        <DatePicker className="form-control" id="enddate" placeholderText="End Date"  name="enddate" autoComplete="off" 
                                                                selected={this.state.enddate}
                                                                onChange={this.selectend}
                                                                dateFormat='yyyy-MM-dd'
                                                                peekNextMonth
                                                                showMonthDropdown
                                                                showYearDropdown
                                                            /> 
                                                    </FormGroup>                                          
                                                </div>
                                                <div className="form-group">     
                                                    <button className="mr-3 mb-3 btn btn-outline-warning" type="button" onClick={() => this.filterDateSubmit()}>Filter</button>                  
                                                                                            
                                                </div>              
                                            </div>
                                        <ResponsiveContainer width='100%' height={300}>
                                            <LineChart data={this.state.putlinedata}>
                                                <XAxis dataKey="x" domain={[0, "auto"]} stroke={ChartConfig.axesColor} />
                                                <YAxis stroke={ChartConfig.axesColor} domain={[0, this.state.putlinemax]}/>
                                                <CartesianGrid vertical={false} stroke={ChartConfig.chartGridColor} />
                                                <Tooltip wrapperStyle={tooltipStyle} cursor={false} itemStyle={tooltipTextStyle} labelStyle={{ display: 'none' }} />
                                                                                
                                                <Line type="bumpX" dataKey="y" stroke={'#FF7F50'} label={{ fill: '#757474', fontSize: 15, position:'top' }} dot={{ strokeWidth: 4 }} activeDot={{ r: 10 }} />
                                            </LineChart>
                                        </ResponsiveContainer>
                                        </div> 
                                        }
                                       <div className="col-lg-12">
                                        <div className="form-group"> 
                                            <button type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" disabled={this.state.loader}>Submit</button>
                                        </div>
                                       </div>
                                    </div>    
                            </RctCollapsibleCard>
                         </div>   
                        </div>
                      </form>
            </div>
            {this.state.loader &&
            <div className="col-lg-12">
                <ProgressLoader />
            </div>
            }
        </div>
              
    )
   
}
 
}

const mapStateToProps = ({ mostlyused}) => {
    const { studentlists, loading } = mostlyused;
    return { studentlists, loading };
   
}


export default connect(mapStateToProps, {
    stdBDTenPutts,
    addBDTenPutts,
    fetchPuttDistance,
})(PuttItems);
